<template>
    <b-card   id="acceso-cuenta">
        <template v-if="isLogged">
            <ui-dotlottie-loader />
            <b-jumbotron class="text-center">
                <p>{{ allOkLegend }}</p>
            </b-jumbotron>
        </template>
        <template v-else>
            <login-form avoid-redirect-on-login placed-backg="none" v-if="mode == 'login'" hide-links>
                <div class="quesion-log">
                    <b>¿No tienes cuenta?</b>
                    <br>
                    <a href="#" @click.prevent="mode = 'createAccount'">Crea una aquí</a>
                </div>
            </login-form>
            <register-from avoid-redirect-on-login placed-backg="none" v-if="mode == 'createAccount'" hide-links>
                <div class="quesion-log">
                    <b>¿Ya tienes cuenta?</b>
                    <br>
                    <a href="#" @click.prevent="mode = 'login'">Inicia sesión aquí</a>
                </div>
            </register-from>
        </template>
    </b-card>
</template>

<script>
import loginForm from '@/js/components/page/user-access/login'
import registerFrom from '@/js/components/page/user-access/register'
export default {
    name: 'accesoCuenta',
    props: {
        allOkLegend: {
            type: String,
            default: 'Haz iniciado sesión correctamente, haz clic en continuar'
        },
        header: {
            type: String,
            _default: 'Acceso de cuenta'
            // default: 'Acceso de cuenta'
        },
        loop: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mode: 'createAccount', // 'createAccount'
            // isLogged: false
        }
    },
    components: {
        loginForm,
        registerFrom
    },
    computed: {
        cHeader() {
            if (this.mode === 'login') {
                return 'Iniciar sesión';
            } else if (this.mode === 'createAccount') {
                return 'Crear mi cuenta BlackFon®';
            }
            return this.header || 'Acceso de cuenta';
        },
        isLogged() {
            return this.$store.getters.isLogged;
        }
    },
    methods: {
        triggerLogged() {
            this.$emit('logged', this.isLogged)
        }
    },
    beforeMount() {
        if (this.isLogged) {
            this.triggerLogged()
        }
    },
    watch: {
        isLogged() {
            this.triggerLogged()
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#acceso-cuenta {

    .quesion-log {
        margin-top: 20px;
        text-align: center;
        margin-bottom: 20px;
        background-color: hsla(0, 0%, 100%, 0.125);
        padding: 1em;
        border: $primary-dark-border;
        border-radius: 0.2em;
    }

    .nav-tabs {
        justify-content: center;
    }

    .anim {
        &-container {
            width: 100%;
            height: auto;
            position: relative;
            padding-top: 50%;
            /* 1:2 aspect ratio */
            padding-top: 33.33%;
            /* 1:3 aspect ratio */
            // padding-top: 66.66%;
            /* 2:3 aspect ratio */
            height: 0;
        }

        & {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    // background-color: #f0f0f0;
    // padding: 20px;
}
</style>